import { useTheme } from '@mui/material';
import {
  GENERAL_DELETION_CLASS,
  GENERAL_GRAMMAR_CLASS,
  GENERAL_HIGHLIGHT_CLASS,
  GENERAL_INSERTION_CLASS,
  GENERAL_PARAPHRASE_CLASS,
  GENERAL_SUGGESTION_CLASS,
  HEAVY_DELETION_CLASS,
  HEAVY_INSERTION_CLASS,
  HEAVY_SUGGESTION_CLASS,
} from 'features/augmented-writing/editor/highlight-blot';
import _ from 'lodash';
import React from 'react';

interface Props {
  dynamicStyles?: string;
}

const EditorStyles: React.FC<Props> = ({ dynamicStyles }) => {
  const theme = useTheme();
  const highlightColor = theme.palette.primary.main;

  return (
    <>
      {!_.isNil(dynamicStyles) ? <style dangerouslySetInnerHTML={{ __html: dynamicStyles }} /> : null}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .${GENERAL_HIGHLIGHT_CLASS} {
              border-image: initial;
            }
            .${GENERAL_SUGGESTION_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor};
            }
            .${HEAVY_SUGGESTION_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor} !important;
            }
            .${GENERAL_DELETION_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor};
            }
            .${HEAVY_DELETION_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor} !important;
            }
            .${GENERAL_INSERTION_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor};
            }
            .${HEAVY_INSERTION_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor} !important;
            }
            .${GENERAL_GRAMMAR_CLASS} {
              border-image: initial;
              border-bottom: 2px dashed gray;
            }
            .${GENERAL_PARAPHRASE_CLASS} {
              border-image: initial;
              border-bottom: 2px solid ${highlightColor};
            }`,
        }}
      />
    </>
  );
};

export default EditorStyles;
